import ModelTC from './ModelMeetings/ModelTC';

export { ModelTC };
